export default [
    {
        name: 'documents',
        path: '/documents',
    },
]
